export default __webpack_public_path__ + "static/media/02_photo.c0449f67.jpg";